import * as types from '../ActionTypes/MembershipPlansActionTypes';

export class MembershipPlansActionCreators {
    // get membership plans
    static getMembershipPlansRequest = () => ({
        type: types.GET_MEMBERSHIP_PLANS_REQUEST,
    });

    static getMembershipPlansSuccess = payload => ({
        type: types.GET_MEMBERRHIP_PLANS_SUCCESS,
        payload,
    });

    static getMembershipPlansFailed = error => ({
        type: types.GET_MEMBERSHIP_PLANS_FAILED,
        payload: error,
    });

    // create new membership plan
    static addMembershipPlanRequest = planData => ({
        type: types.ADD_MEMBERSHIP_PLAN_REQUEST,
        meta: { planData },
    });

    static addMembershipPlanSuccess = payload => ({
        type: types.ADD_MEMBERSHIP_PLAN_SUCCESS,
        payload,
    });

    static addMembershipPlanFailed = error => ({
        type: types.ADD_MEMBERSHIP_PLAN_FAILED,
        payload: error,
    });

    // updat membership plan
    static updateMembershipPlanRequest = (id, planData) => ({
        type: types.UPDATE_MEMBERSHIP_PLAN_REQUEST,
        meta: { id, planData },
    });

    static updateMembershipPlanSuccess = payload => ({
        type: types.UPDATE_MEMBERSHIP_PLAN_SUCCESS,
        payload,
    });

    static updateMembershipPlanFailed = error => ({
        type: types.UPDATE_MEMBERSHIP_PLAN_FAILED,
        payload: error,
    });

    // delete membership plan
    static deleteMembershipPlanRequest = id => ({
        type: types.DELETE_MEMBERSHIP_PLAN_REQUEST,
        meta: { id },
    });

    static deleteMembershipPlanSuccess = payload => ({
        type: types.DELETE_MEMBERSHIP_PLAN_SUCCESS,
        payload,
    });

    static deleteMembershipPlanFailed = error => ({
        type: types.DELETE_MEMBERSHIP_PLAN_FAILED,
        payload: error,
    });
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/MembershipPlansActionCreators.js